/**
 * Version number utilities for taxonomy and prompt versioning.
 */

function parseVersion(version: string): number[] {
  return version.replace(/^v/, '').split('.').map((p) => parseInt(p, 10) || 0);
}

export function incrementMinor(version: string): string {
  const parts = version.split('.');
  if (parts.length === 2) {
    return `${parts[0]}.${parseInt(parts[1], 10) + 1}`;
  }
  return `${version}.1`;
}

export function incrementMajor(version: string): string {
  const parts = version.split('.');
  if (parts.length >= 1) {
    return `${parseInt(parts[0], 10) + 1}.0`;
  }
  return '2.0';
}

export function highestVersion(versions: string[]): string {
  if (versions.length === 0) return '0.0';
  return versions.reduce((best, v) => {
    const a = parseVersion(best);
    const b = parseVersion(v);
    for (let i = 0; i < Math.max(a.length, b.length); i++) {
      if ((b[i] ?? 0) > (a[i] ?? 0)) return v;
      if ((b[i] ?? 0) < (a[i] ?? 0)) return best;
    }
    return best;
  });
}
